import { createRef, useEffect, useRef, useState } from 'react';
import { InputProps } from '.';
import Form from '../Form';
import { IconLoadingWrapper, IconSearchWrapper } from './styles';

export interface InputSearchProps extends InputProps {
  performAction?: (...args: any) => Promise<any>;
  loading?: boolean;
}

const defaulPromise = new Promise((resolve) => {
  resolve(true);
});
const InputSearch = ({
  performAction = () => defaulPromise,
  style,
  loading = false,
  ...rest
}: InputSearchProps) => {
  const input = createRef<HTMLInputElement>();
  const [isFocused, setIsFocused] = useState(false);

  useEffect(() => {
    let inputRef = input.current;

    if (inputRef) {
      inputRef.addEventListener('focus', handleFocus);
      inputRef.addEventListener('blur', handleBlur);
    }

    return () => {
      if (inputRef) {
        inputRef.removeEventListener('focus', handleFocus);
        inputRef.removeEventListener('blur', handleBlur);
      }
    };
  }, []);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  const containerClassName = `input-search-container ${
    isFocused ? 'input-search-container-focused' : ''
  }`;

  return (
    <div style={style} className={containerClassName}>
      <Form.Input
        ref={input}
        className="input-search"
        onFocus={handleFocus}
        borderRadius={8}
        errorMessage={false}
        IconRight={
          <div
            style={{
              padding: '0 10px',
            }}
          >
            {loading ? (
              <IconLoadingWrapper
                className="input-search-icon"
                onClick={() => {
                  input.current?.focus();
                  performAction();
                }}
                width={27}
                height={27}
              />
            ) : (
              <IconSearchWrapper
                className="input-search-icon"
                onClick={() => {
                  input.current?.focus();
                  performAction();
                }}
                width={25}
                height={25}
                fill="#364856"
              />
            )}
          </div>
        }
        onKeyDown={(event: any) => {
          if (event.key === 'Enter') {
            performAction();
          }
        }}
        {...rest}
      />
    </div>
  );
};

export default InputSearch;
